import axios from 'axios';
import VueAxios from 'vue-axios';
import store from './store';
import router from './router';
import Vue from 'vue';
import vSelect from "vue-select";
import App from './App.vue';
import VueMeta from "vue-meta";
import * as Sentry from '@sentry/vue';
import './stylesheet/global.scss';
import tooltip from "@/directives/tooltip";

Vue.config.productionTip = false;

axios.defaults.baseURL = 'https://gadget.demons-gaming.cc';
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-Requested-By'] = 'spa';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.response.use(undefined, (error) =>
{
	if (/*error instanceof Error &&*/ 'undefined' !== typeof error.response)
	{
		console.log('[Axios]', error.response.status, error.response.data.error, error.response);
		if (error.response.status === 403 && error.response.data.error === 'login-required')
		{
			store.dispatch('logout').catch(() => console.error('logout failed'));
		}
	}

	return Promise.reject(error);
});


Vue.use(VueMeta, {
    'theme-color': '#317EFB',
});
Vue.use(VueAxios, axios);
Vue.directive('tooltip', tooltip);

Vue.component('v-select', vSelect);

Vue.mixin(Vue.extend({
    computed: {
        currentUser() {
            return this.$store.state.layoutData.user;
        },
    },
    methods: {
        getUsername(id: number) {
            return this.$store.state.layoutData.usernames[id];
        },
        getAvatar(id: number) {
            return this.$store.state.layoutData.avatars[id];
        }
    }
}));

Sentry.init({
    Vue: Vue,
    dsn: 'https://7173ff52d72238e0aa895730092c6270@sentry.exatek.de/2',
    integrations: [
        Sentry.browserTracingIntegration({router}),
    ],
});

new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
});
